import React from 'react';
import AdminCRUD from './AdminCRUD';

const AdminEarlyBirdDeals = () => {
  const fields = [
    { name: 'destination', label: 'Destination', type: 'text', required: true, placeholder: 'e.g. Vietnam' },
    { name: 'title', label: 'Title', type: 'text', required: true, placeholder: 'e.g. 7 Days Vietnam Heritage Tour', fullWidth: true },
    { name: 'image', label: 'Image URL', type: 'url', required: true, placeholder: 'https://images.unsplash.com/...', fullWidth: true },
    { name: 'price', label: 'Price', type: 'text', required: true, placeholder: 'e.g. ₹35,999' },
    { name: 'originalPrice', label: 'Original Price', type: 'text', required: true, placeholder: 'e.g. ₹48,999' },
    { name: 'discount', label: 'Savings', type: 'text', required: true, placeholder: 'e.g. Save ₹13,000' },
    { name: 'validTill', label: 'Valid Till', type: 'text', required: true, placeholder: 'e.g. 31 Dec 2024' },
    { name: 'travelPeriod', label: 'Travel Period', type: 'text', required: true, placeholder: 'e.g. Feb - Apr 2025' },
    { name: 'includes', label: 'Includes', type: 'textarea', required: true, placeholder: 'e.g. Flights + Hotels + Cruise + Tours', fullWidth: true },
    { name: 'active', label: 'Status', type: 'boolean', checkboxLabel: 'Active', default: true },
  ];

  const columns = [
    { 
      key: 'image', 
      label: 'Image',
      render: (url) => <img src={url} alt="" className="table-thumb" />
    },
    { key: 'destination', label: 'Destination' },
    { key: 'title', label: 'Title' },
    { key: 'price', label: 'Price' },
    { key: 'validTill', label: 'Valid Till' },
    { 
      key: 'active', 
      label: 'Status',
      render: (active) => <span className={`status-badge ${active ? 'active' : 'inactive'}`}>{active ? 'Active' : 'Inactive'}</span>
    },
  ];

  return (
    <AdminCRUD
      title="Early Bird Deals"
      endpoint="early-bird-deals"
      fields={fields}
      columns={columns}
      renderPreview={true}
    />
  );
};

export default AdminEarlyBirdDeals;
